import { render, staticRenderFns } from "./EquipmentItemsTable.vue?vue&type=template&id=eb0cfa10"
import script from "./EquipmentItemsTable.vue?vue&type=script&lang=js"
export * from "./EquipmentItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports